<template>
  <div class="w-[100%]">
    <RenderlessLookup
      v-slot="{ options, setSearch }"
      :endpoint="(props.endpoint as string)"
      :displayKey="props.displayKey"
      :valueKey="(props.valueKey as string)"
      :responseKey="props.responseKey"
      :limit="props.limit"
      :filter="props.filter"
      :currentValue="value"
      :tokenData="props.tokenData"
      v-if="props.fetchOptions"
    >
      <PrimeMultiSelect
        v-model="value"
        :options="options"
        :filter="props.filterEnabled"
        :resetFilterOnHide="props.filterEnabled"
        :autoFilterFocus="true"
        class="w-full"
        @change="
          ($event) => {
            // if (options) {
            //   actualValue = options?.find((opt) => {
            //     return opt.value === $event.value;
            //   }).name;
            // }

            changeEventHandler($event);
          }
        "
        :pt="{
          filterInput: {
            class: 'ml-5 w-[88%]',
          },
        }"
        optionValue="value"
        optionLabel="name"
        :showClear="true"
        v-on:hide="blurEventHandler($event)"
        ref="selectDropdown"
        v-on:blur="blurEventHandler($event)"
        :disabled="loading || disabled"
        :invalid="hasErrors"
        :placeholder="props.placeholder"
        :editable="props.editable"
        display="chip"
        appendTo="self"
        :loading="options?.length == 0 ? true : false"
      >
        <template #headercheckboxicon="slotProps">
          <div class="flex flex-row items-center space-x-2">
            <span
              class="pb-1 pl-[22px] p-checkbox-icon"
              :class="{
                // @ts-ignore
                'opacity-0': !slotProps.checked,
              }"
            >
              <CheckIcon />
            </span>
            <div>All</div>
          </div>
        </template>
      </PrimeMultiSelect>
      <!-- @before-show="populateOptions()" -->
    </RenderlessLookup>
    <template v-else>
      <PrimeMultiSelect
        v-model="value"
        :options="props.options"
        :filter="props.filterEnabled"
        display="chip"
        appendTo="self"
        class="w-full"
        @change="
          ($event) => {
            // if (props.options) {
            //   actualValue = props.options?.find((opt) => {
            //     return opt.value === $event.value;
            //   });
            // }

            changeEventHandler($event);
          }
        "
        :pt="{
          filterInput: {
            class: 'ml-5 w-[80%]',
          },
        }"
        :optionValue="props.valueKey"
        :optionLabel="props.displayKey"
        :showClear="true"
        v-on:hide="blurEventHandler($event)"
        ref="selectDropdown"
        v-on:blur="blurEventHandler($event)"
        :disabled="loading || disabled"
        :invalid="hasErrors"
        :placeholder="props.placeholder"
        :editable="props.editable"
        :loading="props.options?.length == 0 ? true : false"
      >
        <template #headercheckboxicon="slotProps">
          <div class="flex flex-row items-center space-x-2">
            <span
              class="pb-1 pl-[22px] p-checkbox-icon"
              :class="{
                // @ts-ignore
                'opacity-0': !slotProps.checked,
              }"
            >
              <i class="pi pi-check" />
            </span>
            <div>All</div>
          </div>
        </template>
      </PrimeMultiSelect>
    </template>
  </div>
</template>

<script setup lang="ts">
import {
  type IInputEvent,
  type IChangeEvent,
  type IBlurEvent,
} from "~/scad-shared/types/interfaces";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    inputType?: string;
    error?: string;
    loading?: boolean;
    id?: string;
    options?: any[];
    fetchOptions?: boolean;
    editable?: boolean;
    endpoint?: string;
    displayKey?: string;
    valueKey?: string;
    responseKey?: string;
    limit?: number;
    filterEnabled?: boolean;
    filter?: { [key: string]: any };
    tokenData?: { [key: string]: any };
    placeholder?: string;
  }>(),
  {
    disabled: false,
    editable: false,
    loading: false,
    fetchOptions: false,
    responseKey: "Results",
    limit: 0, //no limit on multi-selects
    filterEnabled: false, //no filter on multi-selects
    filter: () => ({}),
  }
);

const value = defineModel<any>("value");
//const actualValue = defineModel<any>("actual");

const hasErrors: ComputedRef<boolean> = computed(() => {
  if (props.error && props.error !== "") {
    return true;
  }
  return false;
});

const emits = defineEmits<{
  change: [event: IInputEvent];
  input: [event: IChangeEvent];
  blur: [event: IBlurEvent];
}>();

function changeEventHandler($event: any) {
  emits("change", { ...$event, value: value.value });
}
function inputEventHandler($event: any) {
  emits("input", { ...$event, value: value.value });
}
function blurEventHandler($event: any) {
  emits("blur", { ...$event, value: value.value });
}
</script>

<style scoped></style>
